<kui-card>
    <kui-card-body class="text-center">
        @if (searching) {
            <kui-card-body class="text-center">
                <kui-loader size="small"> </kui-loader>
            </kui-card-body>
        }
        @if (!searching && !results?.length) {
            <div>{{ "LEAFLET.NO_RESULTS" | translate }}</div>
        }
        @if (!searching && results?.length) {
            <key-search-results-list [list]="results" [highlightValue]="term$ | async" (onSelected)="hideSearchList()"> </key-search-results-list>
        }
    </kui-card-body>
</kui-card>
